import {
	SET_LOADING,
	UPDATE_CHALLENGE_SPACE_EVALUATION_STATE,
	UPDATE_CHALLENGE_SPACE_STUDENT_REGISTRATION_STATE,
} from './index'
import ToastService from '../../services/toast.service'
import ConfirmService from '../../services/confirm.service'

import {
	ADD_ACCOUNT_CHALLENGE_SPACE,
	FILTER_ACCOUNT_CHALLENGE_SPACES,
	LOAD_MORE_CHALLENGE_SPACES,
	SET_ACCOUNT_CHALLENGE_SPACE_DISTRIBUTION,
	SET_ACCOUNT_CHALLENGE_SPACE_MAILINGS,
	SET_ACCOUNT_CHALLENGE_SPACE_NOTE,
	SET_ACCOUNT_CHALLENGE_SPACE_RANKINGS,
	SET_ACCOUNT_CHALLENGE_SPACE_TEAM_FORMATION_CONFIG,
	SET_ACCOUNT_CHALLENGE_SPACE,
	SET_ACCOUNT_CHALLENGE_SPACES,
	SET_CHALLENGE_SPACES,
	SET_FEATURED_CHALLENGE_SPACES,
	SET_SUBMIT_CHALLENGE_SPACE,
	CLEAR_ACCOUNT_CHALLENGE_SPACE,
	UPDATE_CHALLENGE_SPACE_CHALLENGE_RECRUITMENT_STATE,
	UPDATE_CHALLENGE_SPACE_CHALLENGE_RANKING_STATE,
	UPDATE_CHALLENGE_SPACE_STATE,
	UPDATE_CHALLENGE_SPACE_TEAM_REGISTRATION_STATE,
	UPDATE_CHALLENGE_SPACE_TEAM_RANKING_STATE,
	DUPLICATE_CHALLENGE_SPACE,
} from './'
import ChallengeSpaceService from '../../services/challenge-space.service'
import Router from 'next/router'

const setFeaturedChallengeSpaces: any = (payload: object) => {
	return async (dispatch: any) => {
		await ChallengeSpaceService.getPublicChallengeSpaces(payload).then(
			(response) => {
				dispatch({
					type: SET_FEATURED_CHALLENGE_SPACES,
					response: response,
				})
			}
		)
	}
}

const setChallengeSpaces: any = (
	payload: object,
	loadmore: boolean = false
) => {
	return async (dispatch: any) => {
		await ChallengeSpaceService.getPublicChallengeSpaces(payload).then(
			(response) => {
				if (loadmore) {
					dispatch({
						type: LOAD_MORE_CHALLENGE_SPACES,
						response: response,
					})
				} else {
					dispatch({
						type: SET_CHALLENGE_SPACES,
						response: response,
					})
				}
			}
		)
	}
}

const setSubmitChallengeSpace: any = (challengeSpaceId: string) => {
	return async (dispatch: any) => {
		await ChallengeSpaceService.getPublicChallengeSpace(challengeSpaceId)
			.then((response) => {
				dispatch({
					type: SET_SUBMIT_CHALLENGE_SPACE,
					response: response,
				})
			})
			.catch(() => {
				dispatch({
					type: SET_SUBMIT_CHALLENGE_SPACE,
					response: null,
				})
			})
	}
}

const setAccountChallengeSpaces = (
	payload: object,
	filter: boolean = false
) => {
	return async (dispatch: any) => {
		await ChallengeSpaceService.getUserChallengeSpaces(payload)
			.then((response) => {
				if (!filter) {
					dispatch({
						type: SET_ACCOUNT_CHALLENGE_SPACES,
						response: response,
					})
					return
				}
				dispatch({
					type: FILTER_ACCOUNT_CHALLENGE_SPACES,
					response: response,
				})
			})
			.catch((error) => console.log(error))
	}
}

const setAccountChallengeSpace = (challengeSpaceId: string) => {
	return async (dispatch: any) => {
		await ChallengeSpaceService.getUserChallengeSpace(challengeSpaceId).then(
			(response) => {
				dispatch({
					type: SET_ACCOUNT_CHALLENGE_SPACE,
					response: response,
				})
			}
		)
	}
}

const clearAccountChallengeSpace = () => {
	return async (dispatch: any) => {
		dispatch({
			type: CLEAR_ACCOUNT_CHALLENGE_SPACE,
		})
	}
}

const updateAccountChallengeSpace = (challengeSpaceId: string, params: any) => {
	return async () => {
		await ChallengeSpaceService.updateUserChallengeSpace(
			challengeSpaceId,
			params
		).then(() => {
			return
		})
	}
}

const createAccountChallengeSpace = (params: any) => {
	return async (dispatch: any) => {
		await ChallengeSpaceService.createAccountChallengeSpace(params).then(
			(response) => {
				dispatch({
					type: ADD_ACCOUNT_CHALLENGE_SPACE,
					response: response,
				})
				dispatch({
					type: SET_ACCOUNT_CHALLENGE_SPACE,
					response: response,
				})
			}
		)
	}
}

const getChallengeSpaceDistribution = (challengeSpaceId: string) => {
	return async (dispatch: any) => {
		await ChallengeSpaceService.getChallengeSpaceDistribution(
			challengeSpaceId
		).then((response) => {
			dispatch({
				type: SET_ACCOUNT_CHALLENGE_SPACE_DISTRIBUTION,
				challengeSpaceId: challengeSpaceId,
				response: response,
			})
		})
	}
}

const getChallengeSpaceRankings = (challengeSpaceId: string) => {
	return async (dispatch: any) => {
		await ChallengeSpaceService.getChallengeSpaceRankings(
			challengeSpaceId
		).then((response) => {
			dispatch({
				type: SET_ACCOUNT_CHALLENGE_SPACE_RANKINGS,
				challengeSpaceId: challengeSpaceId,
				response: response,
			})
		})
	}
}

const updateChallengeSpaceState = (
	payload: {
		challengeSpaceId: string
		state: 0 | 1
	},
	onFinish = null
) => {
	const type = payload.state == 1 ? 'activate' : 'deactivate'

	return async (dispatch: any) => {
		await ConfirmService.confirm({
			title: `Are you sure you want to ${type} this challenge space?`,
		}).then((result) => {
			if (result.value) {
				return ChallengeSpaceService.updateChallengeSpaceState(
					payload.challengeSpaceId,
					{ state: payload.state }
				).then((response) => {
					if (response.errors) {
						throw new Error(response.errors)
					}

					ToastService.showSuccess(`Challenge space ${type}d`)
					dispatch({
						type: UPDATE_CHALLENGE_SPACE_STATE,
						response: {
							challengeSpaceId: payload.challengeSpaceId,
							state: payload.state == 1 ? 'active' : 'inactive',
						},
					})
					if (onFinish) {
						onFinish()
					}
				})
			}
		})
	}
}

const duplicateChallengeSpace = (payload: { challengeSpaceId: string }) => {
	return async (dispatch: any) => {
		await ConfirmService.confirm({
			title: `Are you sure you want to duplicate this challenge space?`,
		}).then((result) => {
			if (result.value) {
				return ChallengeSpaceService.duplicateChallengeSpace(
					payload.challengeSpaceId
				).then((response) => {
					if (response.errors) {
						throw new Error(response.errors)
					}

					ToastService.showSuccess(`Challenge space duplicated`)

					dispatch({
						type: DUPLICATE_CHALLENGE_SPACE,
						response: response,
					})
					const newChallengeSpace = Object.keys(response.challengeSpace).map(
						(k) => response.challengeSpace[k]
					)[0].id
					Router.push(`/account/challenge-spaces/${newChallengeSpace}`)
				})
			}
		})
	}
}

const setChallengeRecruitmentStatus = (
	spaceId: string,
	params: any,
	edit: boolean = false
) => {
	const type = params.isChallengeRecruitmentActive ? 'start' : 'stop'

	return async (dispatch: any) => {
		let result = { value: true } as any
		if (!edit) {
			result = await ConfirmService.confirm({
				title: `Are you sure you want to ${type} the challenge recruitment period?`,
				confirmButtonText: `${type == 'start' ? 'Start' : 'Stop'} period`,
				customClass: {
					confirmButton: `bg-${
						type == 'start' ? 'green' : 'red'
					}-500 text-white mr-4`,
					cancelButton: 'bg-gray-200 text-gray-800',
				},
			})
		}

		if (result.value) {
			return ChallengeSpaceService.setChallengeRecruitmentStatus(
				spaceId,
				params
			).then((response) => {
				if (response.errors) {
					throw new Error(response.errors)
				}

				if (type == 'start') {
					ToastService.showSuccess(
						`Challenge recruitment period ${edit ? 'saved' : 'started'}!`
					)
				} else {
					ToastService.showSuccess('Challenge recruitment period stopped!')
				}

				dispatch({
					type: UPDATE_CHALLENGE_SPACE_CHALLENGE_RECRUITMENT_STATE,
					response: response,
					challengeSpaceId: spaceId,
				})
			})
		}
	}
}

const setChallengeRankingStatus = (
	spaceId: string,
	params: any,
	edit: boolean = false
) => {
	const type = params.isChallengeRankingActive ? 'start' : 'stop'

	return async (dispatch: any) => {
		let result = { value: true } as any
		if (!edit) {
			result = await ConfirmService.confirm({
				title: `Are you sure you want to ${type} the challenge ranking period?`,
				confirmButtonText: `${type == 'start' ? 'Start' : 'Stop'} period`,
				customClass: {
					confirmButton: `bg-${
						type == 'start' ? 'green' : 'red'
					}-500 text-white mr-4`,
					cancelButton: 'bg-gray-200 text-gray-800',
				},
			})
		}
		if (result.value) {
			return ChallengeSpaceService.setChallengeRankingStatus(
				spaceId,
				params
			).then((response) => {
				if (response.errors) {
					throw new Error(response.errors)
				}

				if (type == 'start') {
					ToastService.showSuccess(
						`Challenge ranking period ${edit ? 'saved' : 'started'}!`
					)
				} else {
					ToastService.showSuccess('Challenge ranking period stopped!')
				}

				dispatch({
					type: UPDATE_CHALLENGE_SPACE_CHALLENGE_RANKING_STATE,
					response: response,
					challengeSpaceId: spaceId,
				})
			})
		}
	}
}

const setTeamRankingStatus = (
	spaceId: string,
	params: any,
	edit: boolean = false
) => {
	const type = params.isStudentRankingActive ? 'start' : 'stop'

	return async (dispatch: any) => {
		let result = { value: true } as any
		if (!edit) {
			result = await ConfirmService.confirm({
				title: `Are you sure you want to ${type} the team ranking period?`,
				confirmButtonText: `${type == 'start' ? 'Start' : 'Stop'} period`,
				customClass: {
					confirmButton: `bg-${
						type == 'start' ? 'green' : 'red'
					}-500 text-white mr-4`,
					cancelButton: 'bg-gray-200 text-gray-800',
				},
			})
		}

		if (result.value) {
			return ChallengeSpaceService.setTeamRankingStatus(spaceId, params).then(
				(response) => {
					if (response.errors) {
						throw new Error(response.errors)
					}

					if (type == 'start') {
						ToastService.showSuccess(
							`Team ranking period ${edit ? 'saved' : 'started'}!`
						)
					} else {
						ToastService.showSuccess('Team ranking period stopped!')
					}

					dispatch({
						type: UPDATE_CHALLENGE_SPACE_TEAM_RANKING_STATE,
						response: response,
						challengeSpaceId: spaceId,
					})
				}
			)
		}
	}
}

const registerTeam = (spaceId: string, params: any, code?: string) => {
	return async () => {
		await ChallengeSpaceService.createTeam(spaceId, params, code)
	}
}

const setTeamRegistrationStatus = (
	spaceId: string,
	params: any,
	edit: boolean = false
) => {
	const type = params.isActive ? 'open' : 'close'

	return async (dispatch: any) => {
		let result = { value: true } as any
		if (!edit) {
			result = await ConfirmService.confirm({
				title: `Are you sure you want to ${type} the team registration?`,
				confirmButtonText: `${type == 'open' ? 'Open' : 'Close'} registration`,
				customClass: {
					confirmButton: `bg-${
						type == 'open' ? 'green' : 'red'
					}-500 text-white mr-4`,
					cancelButton: 'bg-gray-200 text-gray-800',
				},
			})
		}

		if (result.value) {
			return ChallengeSpaceService.setTeamRegistrationStatus(
				spaceId,
				params
			).then((response) => {
				if (response.errors) {
					throw new Error(response.errors)
				}

				if (type == 'open') {
					ToastService.showSuccess(
						`Team registration ${edit ? 'saved' : 'opened'}!`
					)
				} else {
					ToastService.showSuccess('Team registration closed!')
				}

				dispatch({
					type: UPDATE_CHALLENGE_SPACE_TEAM_REGISTRATION_STATE,
					response: response,
					challengeSpaceId: spaceId,
				})
			})
		}
	}
}

const updateStudentRegistrationState = (
	spaceId: string,
	params: any,
	edit: boolean = false
) => {
	const type = params.isActive ? 'open' : 'close'

	return async (dispatch: any) => {
		let result = { value: true } as any
		if (!edit) {
			result = await ConfirmService.confirm({
				title: `Are you sure you want to ${type} the student registration?`,
				confirmButtonText: `${type == 'open' ? 'Open' : 'Close'} registration`,
				customClass: {
					confirmButton: `bg-${
						type == 'open' ? 'green' : 'red'
					}-500 text-white mr-4`,
					cancelButton: 'bg-gray-200 text-gray-800',
				},
			})
		}

		if (result.value) {
			return ChallengeSpaceService.setStudentRegistrationState(
				spaceId,
				params
			).then((response) => {
				if (response.errors) {
					throw new Error(response.errors)
				}

				if (type == 'open') {
					ToastService.showSuccess(
						`Student registration ${edit ? 'saved' : 'opened'}!`
					)
				} else {
					ToastService.showSuccess('Student registration closed!')
				}

				dispatch({
					type: UPDATE_CHALLENGE_SPACE_STUDENT_REGISTRATION_STATE,
					response: response,
					challengeSpaceId: spaceId,
				})
			})
		}
	}
}

const updateEvaluationState = (
	spaceId: string,
	params: any,
	edit: boolean = false
) => {
	const type = params.isEvaluationActive ? 'start' : 'stop'

	return async (dispatch: any) => {
		let result = { value: true } as any
		if (!edit) {
			result = await ConfirmService.confirm({
				title: `Are you sure you want to ${type} the evaluation?`,
				text: `A notification will be sent to the challenge owners`,
				confirmButtonText: `${type == 'start' ? 'Start' : 'Stop'} evaluation`,
				customClass: {
					confirmButton: `bg-${
						type == 'start' ? 'green' : 'red'
					}-500 text-white mr-4`,
					cancelButton: 'bg-gray-200 text-gray-800',
				},
			})
		}

		if (result.value) {
			return ChallengeSpaceService.setEvaluationState(spaceId, params).then(
				(response) => {
					if (response.errors) {
						throw new Error(response.errors)
					}

					if (type == 'start') {
						ToastService.showSuccess(
							`Evaluation ${edit ? 'saved' : 'started'}!`
						)
					} else {
						ToastService.showSuccess('Evaluation stopped!')
					}

					dispatch({
						type: UPDATE_CHALLENGE_SPACE_EVALUATION_STATE,
						response: response,
						challengeSpaceId: spaceId,
					})
				}
			)
		}
	}
}

const setChallengeSpaceMailings = (spaceId: string, params: any) => {
	return async (dispatch: any) => {
		await ChallengeSpaceService.getChallengeSpaceMailings(spaceId, params).then(
			(response) => {
				dispatch({
					type: SET_ACCOUNT_CHALLENGE_SPACE_MAILINGS,
					challengeSpaceId: spaceId,
					response: response,
				})
			}
		)
	}
}

const setChallengeSpaceNote = (spaceId: string) => {
	return async (dispatch: any) => {
		await ChallengeSpaceService.getChallengeSpaceNote(spaceId).then(
			(response) => {
				dispatch({
					type: SET_ACCOUNT_CHALLENGE_SPACE_NOTE,
					challengeSpaceId: spaceId,
					response: response,
				})
			}
		)
	}
}

const updateChallengeSpaceNote = (spaceId: string, params: any) => {
	return async (dispatch: any) => {
		await ChallengeSpaceService.updateChallengeSpaceNote(spaceId, params).then(
			(response) => {
				dispatch({
					type: SET_ACCOUNT_CHALLENGE_SPACE_NOTE,
					challengeSpaceId: spaceId,
					response: response,
				})
			}
		)
	}
}

const setTeamFormationConfig = (spaceId: string, params: any) => {
	return async (dispatch: any) => {
		dispatch({ type: SET_LOADING, response: true })
		await ChallengeSpaceService.getChallengeSpaceTeamFormation(
			spaceId,
			params
		).then((response) => {
			dispatch({
				type: SET_ACCOUNT_CHALLENGE_SPACE_TEAM_FORMATION_CONFIG,
				challengeSpaceId: spaceId,
				response: response,
			})
			dispatch({ type: SET_LOADING, response: false })
		})
	}
}

const updateTeamFormationConfig = (
	spaceId: string,
	teamFormationId: string,
	params: any
) => {
	return async (dispatch: any) => {
		await ChallengeSpaceService.updateChallengeSpaceTeamFormation(
			spaceId,
			teamFormationId,
			params
		).then((response) => {
			dispatch({
				type: SET_ACCOUNT_CHALLENGE_SPACE_TEAM_FORMATION_CONFIG,
				challengeSpaceId: spaceId,
				response: response,
			})
			ToastService.showSuccess(`Team formation settings saved!`)
		})
	}
}

const createTeamFormationConfig = (spaceId: string, params: any) => {
	return async (dispatch: any) => {
		await ChallengeSpaceService.createChallengeSpaceTeamFormation(
			spaceId,
			params
		).then((response) => {
			dispatch({
				type: SET_ACCOUNT_CHALLENGE_SPACE_TEAM_FORMATION_CONFIG,
				challengeSpaceId: spaceId,
				response: response,
			})
			ToastService.showSuccess(`Team formation settings saved!`)
		})
	}
}

export {
	setFeaturedChallengeSpaces,
	setChallengeSpaces,
	setSubmitChallengeSpace,
	setAccountChallengeSpaces,
	setAccountChallengeSpace,
	clearAccountChallengeSpace,
	updateChallengeSpaceState,
	createAccountChallengeSpace,
	updateAccountChallengeSpace,
	setChallengeRecruitmentStatus,
	setChallengeRankingStatus,
	setTeamRankingStatus,
	setTeamRegistrationStatus,
	getChallengeSpaceDistribution,
	getChallengeSpaceRankings,
	registerTeam,
	setChallengeSpaceMailings,
	setChallengeSpaceNote,
	updateChallengeSpaceNote,
	setTeamFormationConfig,
	updateTeamFormationConfig,
	createTeamFormationConfig,
	updateStudentRegistrationState,
	updateEvaluationState,
	duplicateChallengeSpace,
}
